import React from 'react'
import VBTeams from '../components/VBTeams'

const Teams = () => {
  return <VBTeams isPublic={true} />
}

export default Teams
